<div
  class="rich-text"
  [hidden]="showMode"
>
  @if (label) {
    <mat-label
      class="rich-text__label"
      [class.rich-text__label--invalid]="control.enabled && (invalid || !control.valid)"
    >
      @if (hint) {
        <mat-icon
          class="rich-text__hint"
          [matTooltip]="hint"
        >
          info
        </mat-icon>
      }
      <div class="rich-text__label-text">
        {{ label }}
      </div>
      @if (isRequired && !showMode) {
        <span class="input-required"> * </span>
      }
    </mat-label>
  }
  <div class="rich-text__control">
    @if (showFullScreenButton) {
      <button
        class="rich-text__full-screen"
        procure-button
        condensed
        color="white"
        matTooltip="Edit in full screen"
        (click)="enterFullscreen()"
      >
        <mat-icon class="rich-text__full-screen-icon">fullscreen</mat-icon>
      </button>
    }
    <ckeditor
      [formControl]="control"
      [editor]="editor"
      [config]="editorConfig"
    />
  </div>
</div>
<procure-show-field
  [hidden]="!showMode"
  [label]="label"
  [hint]="hint"
>
  <pre [innerHTML]="html ? (value | safeHtml) : value"></pre>
</procure-show-field>
